import { Component, Input, OnInit } from '@angular/core';
import { ControllerService } from '../services/controller.service';


@Component({
    selector: 'app-library-button',
    templateUrl: './library-button.component.html',
    styleUrls: ['./library-button.component.scss'],
    standalone: false
})
export class LibraryButtonComponent implements OnInit {

  @Input() additionalCssClass: string = ''

  constructor(public controller: ControllerService) { }

  ngOnInit() {
  }

}
